import { useEffect, useRef, useState } from 'react'

type CommanFooterCardProps = {
  paragraph: string
  imageSrc: string
  imageAlt: string
  overlayGradient?: string
  textColorClassName?: string
}

const defaultOverlay =
  'linear-gradient(0deg, #744DFF 17.11%, rgba(116, 77, 255, 0) 100%)'

const CommanFooterCard = ({
  paragraph,
  imageSrc,
  imageAlt,
  overlayGradient = defaultOverlay,
  textColorClassName = 'text-gray-100',
}: CommanFooterCardProps) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(entry.isIntersecting)
      },
      { threshold: 0.3 }
    )

    if (ref.current) observer.observe(ref.current)

    return () => observer.disconnect()
  }, [])

  return (
    <section
      ref={ref}
      className="relative mt-14 mb-15 w-full overflow-hidden"
    >
      {/* 🔥 ANIMATION CSS */}
      <style>{`
        .scale-base {
          transition: all 0.9s ease-in-out;
        }

        .scale-enter {
          transform: scale(0.9); /* smoother than 0.75 */
          opacity: 0;
        }

        .scale-show {
          transform: scale(1);
          opacity: 1;
        }
      `}</style>

      <div
        className={`
          relative w-full
          h-[220px]
          sm:h-[240px]
          md:h-[260px]
          lg:h-[300px]
          xl:h-[340px]
          2xl:h-[380px]
          scale-base
          ${visible ? 'scale-show' : 'scale-enter'}
        `}
      >
        {/* ✅ Background Image FIXED */}
        <img
          src={imageSrc}
          alt={imageAlt}
          className="absolute inset-0 w-full h-full object-cover block"
        />

        {/* Overlay */}
        <div
          className="absolute inset-0"
          style={{ background: overlayGradient }}
        />

        {/* Text */}
        <p
          className={`absolute left-1/2 top-1/2 z-10 w-[88%] -translate-x-1/2 -translate-y-1/2 text-center font-gilroy-medium text-lg leading-relaxed [word-spacing:4px] md:text-2xl lg:text-2xl xl:text-3xl 2xl:w-[70%] 2xl:text-4xl ${textColorClassName}`}
        >
          {paragraph}
        </p>
      </div>
    </section>
  )
}

export default CommanFooterCard